import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import BaseLabel from "components/BaseLabel";
import { Grid } from "@mui/material";

import { InputGeneral } from "components/Input";

interface Props {
  mConfWebhook?: string;
  textFieldValue?: string;
  setTextFieldValue?: (e: string) => void;
  errorSIAuthent: any;
  setErrorSIAuthent: (e: any) => void;
}

const MConfWebhookConfiguration: React.FC<Props> = ({
  mConfWebhook,
  setTextFieldValue,
  errorSIAuthent,
  setErrorSIAuthent,
}) => {
  const { t } = useTranslation();
  let parsedObject: Record<string, string> = {};
  try {
    parsedObject = mConfWebhook ? JSON.parse(mConfWebhook) : {};
  } catch (err) {
    parsedObject = {};
  }

  const defaultTemplate: Record<string, string> = {
    CallbackUrl: "",
    AuthToken: "",
    HookId: "",
  };

  const [formValues, setFormValues] = useState<Record<string, string>>({
    ...defaultTemplate,
    ...parsedObject,
  });

  useEffect(() => {
    setTextFieldValue &&
      setTextFieldValue(JSON.stringify(formValues, null, 4));
    setErrorSIAuthent(null);
  }, [formValues]);

  const handleChange = (key: string, value: string) => {
    setFormValues((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <Grid container spacing={2} style={{ padding: "16px" }}>
      <Grid item xs={12}>
        <BaseLabel
          fontSize="18px"
          fontWeight="700"
          marginBottom="0px"
          marginTop="0px"
          marginLeft="0px"
          marginRight="0px"
        >
          {t("systemConfiguration.mConfWebhook.title")}
        </BaseLabel>
      </Grid>

      {Object.keys(formValues).map((key) => (
        <Grid item xs={12} key={key}>
          <InputGeneral
            label={key}
            value={formValues[key]}
            onChange={(val) => handleChange(key, val)}
            required
            width={381}
            maxLength={500}
            error={false}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default MConfWebhookConfiguration; 